module.exports = __webpack_public_path__ + "img/gro.f7f37368.png";